    import * as React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

const ITEM_HEIGHT = 48;

export default function BasicMenu({placeholder, onClick, customWidth, menuOptions}) {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);


    };
    const handleClose = () => {
        setAnchorEl(null);
        onClick()
    };

    return (
        <div>
            <Button
                id="basic-button"
                aria-controls="long-menu"
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}
                variant='outlined'
                endIcon={<KeyboardArrowDownIcon style={{marginLeft: 15}}/>}
                style={{
                    color: '#DE5103',
                    borderColor: '#DE5103',
                    width: '100%',
                    backgroundColor: 'white',
                    textTransform: "lowercase",
                    fontSize: 13
                }}
            >
                <span style={{color: '#B5A9AD'}}>
                    {placeholder}
                </span>
            </Button>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'long-button',
                }}
                PaperProps={{
                    style: {
                        maxHeight: ITEM_HEIGHT * 4.5,
                        width: customWidth,
                        marginTop: 10,
                        borderColor: '#DE5103',
                        borderWidth: 1
                    },
                }}
            >
                <MenuItem onClick={handleClose}>College Preps</MenuItem>
                <MenuItem onClick={handleClose}>Cambridge</MenuItem>
                <MenuItem onClick={handleClose}>Skillhub</MenuItem>
                <MenuItem onClick={handleClose}>Necta</MenuItem>
                <MenuItem onClick={handleClose}>IB</MenuItem>
            </Menu>
        </div>
    );
}
